<template>
  <div>
    <BaseTitle :title="$t('content.view_pages')" :yearPeriode="titleData" />

    <v-card>
      <div>
        <v-card class="pa-5 d-flex justify-space-between align-items section-header active" flat tile>
          <div class="student-title">{{ datas.title }}</div>
          <div v-if="isStudent === false">
            <template>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <span dark v-bind="attrs" v-on="on">
                    <svg-icon icon="ic-moreaction-black" class="mt-1" />
                  </span>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title class="text-dropdown" style="cursor: pointer;" @click="edit()">{{ $t('edit') }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </div>
        </v-card>
        <div class="border-item pa-8">
          <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
          <article v-if="datas.content" class="container mb-5" v-html="datas.content" />
          <span v-else>-</span>
        </div>
      </div>
    </v-card>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'StudentViewSyllabus',
  components: {
    BaseTitle
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateModule({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      var backModules = localStorage.getItem('backModules');
      if (classId == currentClassId && courseId == currentCourseId && backModules) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_module') });
        setTimeout(() => {
          this.$router.push({ name: 'ModulesStudentIndexClass' });
        }, 400);
      }
    }
  },
  data: () => ({
    dataClass: '',
    datas: '',
    loadingLoad: false,
    titleData: ''
  }),
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Pages/fetchDetail', this.$route.params.id)
        .then(res => {
          this.datas = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    edit() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'PagesEditClass', params: { id: this.datas.pagesId } });
      } else {
        this.$router.push({ name: 'PagesSectionEditClass', params: { id: this.datas.pagesId } });
      }
    },
    back() {
      const hasBackModules = !!localStorage.getItem('backModules');
      const hasSection = !!this.$route.params.classSectionId;

      if (hasBackModules) {
        this.$router.back();
        return;
      }

      if (this.isClass && !this.isStudent) {
        this.$router.push({
          name: hasSection ? 'PagesSectionIndexClass' : 'PagesIndexClass'
        });
        return;
      }

      if (this.isClass && this.isStudent) {
        this.$router.push({ name: 'ModulesStudentIndexClass' });
        return;
      }

      this.$router.back();
    }
  },
  created() {
    if (this.isClass) {
      this.getData();
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
